// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"Menu_logoContainer__4tYev","jfyLogo":"Menu_jfyLogo__1o4po"};